import BasicInfo from './basic-info';

export default BasicInfo;

export {
    BasicInfo,
};
